import Api from '@/services/Api';

export default {
  namespaced: true,
  state: {
    servicesFamilies: [],
    idFamilySelected: null,
    idTipoMuestra: null,
    servicesAnalytics: [],
    servicesAnalyticsDetails: [],
    serviceParameters: [],
    serviceNoAnalytics: [],
    showCatalogDetailsPopup: false,
    popupTitle: '',
    sampleTypes: [],
  },
  actions: {
    // Llamada para cargar el listado de familias de servicios
    async fetchServicesFamilies({ commit }) {
      try {
        const xhr = await Api.getServicesCatalogFamilies();
        const response = JSON.parse(xhr.response);
        commit('setServicesFamilies', response);
        commit('setIdFamilySelected', response[0].idFamiliaTM);
        return Promise.resolve();
      } catch (error) {
        return Promise.reject(error);
      }
    },
    async fetchServices({ commit, rootState, state }) {
      try {
        // Pendiente añadir idTipoMuestra para enviar a la función y que cargue cuando se haya seleccionado
        const codCliente = rootState.contact.company;
        const empresa = codCliente.split('-')[0]; // Obtengo el código de país del código de cliente
        const divisa = rootState.contact.addresses[0]?.currency;
        const xhr = await Api.getServiceCatalogAnalytics(
          empresa,
          state.idFamilySelected,
          state.idTipoMuestra,
          divisa,
          codCliente
        );
        const response = JSON.parse(xhr.response);
        commit('setServicesAnalytics', response);
        return Promise.resolve();
      } catch (error) {
        return Promise.reject(error);
      }
    },
    async fetchServicesCatalogParameters({
      commit,
      rootState,
      state,
    }) {
      try {
        const codCliente = rootState.contact.company;
        const empresa = codCliente.split('-')[0];
        const divisa = rootState.contact.addresses[0]?.currency;
        const xhr = await Api.getServicesCatalogParameters(
          empresa,
          state.idTipoMuestra,
          divisa
        );
        const response = JSON.parse(xhr.response);
        commit('setServiceParameters', response);
        return Promise.resolve();
      } catch (error) {
        return Promise.reject(error);
      }
    },
    async fetchServicesAnalyticsDetails({ commit }, data) {
      try {
        commit('setServicesAnalyticsDetails', []);
        const xhr = await Api.getServiceCatalogAnalyticsDetails(data);
        const response = JSON.parse(xhr.response);
        commit('setServicesAnalyticsDetails', response);
        return Promise.resolve(response);
      } catch (error) {
        return Promise.reject(error);
      }
    },
    async fetchServiceNoAnalytics({ commit, rootState }) {
      try {
        const codCliente = rootState.contact.company;
        const empresa = codCliente.split('-')[0];
        const divisa = rootState.contact.addresses[0]?.currency;
        const xhr = await Api.getServiceCatalogNoAnalytics(
          empresa,
          divisa
        );
        const response = JSON.parse(xhr.response);
        commit('setServiceNoAnalytics', response);
        return Promise.resolve();
      } catch (error) {
        return Promise.reject(error);
      }
    },
    async fetchSampleTypes({ commit, state }, sampletype) {
      try {
        const xhr = await Api.getSampleTypesQuery(
          sampletype,
          state.idFamilySelected
        );
        const response = JSON.parse(xhr.response);
        commit('setSampleTypes', response);
        return Promise.resolve();
      } catch (error) {
        return Promise.reject(error);
      }
    },
    setShowCatalogDetailsPopup({ commit }, value) {
      commit('setShowCatalogDetailsPopup', value);
    },
    setServicesFamilies({ commit }, value) {
      commit('setServicesFamilies', value);
    },
    setIdFamilySelected({ commit }, value) {
      commit('setIdFamilySelected', value);
    },
    setIdTipoMuestra({ commit }, value) {
      commit('setIdTipoMuestra', value);
    },
    setServicesAnalytics({ commit }, value) {
      commit('setServicesAnalytics', value);
    },
    setServicesAnalyticsDetails({ commit }, value) {
      commit('setServicesAnalyticsDetails', value);
    },
    setServiceParameters({ commit }, value) {
      commit('setServiceParameters', value);
    },
    setServiceNoAnalytics({ commit }, value) {
      commit('setServicesAnalytics', value);
    },
    setPopupTitle({ commit }, value) {
      commit('setPopupTitle', value);
    },
    setSampleTypes({ commit }, value) {
      commit('setSampleTypes', value);
    },
  },
  mutations: {
    setServicesFamilies(state, value) {
      state.servicesFamilies = value;
    },
    setIdFamilySelected(state, value) {
      state.idFamilySelected = value;
    },
    setIdTipoMuestra(state, value) {
      state.idTipoMuestra = value;
    },
    setServicesAnalytics(state, value) {
      state.servicesAnalytics = value;
    },
    setServicesAnalyticsDetails(state, value) {
      state.servicesAnalyticsDetails = value;
    },
    setShowCatalogDetailsPopup(state, value) {
      state.showCatalogDetailsPopup = value;
    },
    setServiceParameters(state, value) {
      state.serviceParameters = value;
    },
    setServiceNoAnalytics(state, value) {
      state.serviceNoAnalytics = value;
    },
    setPopupTitle(state, value) {
      state.popupTitle = value;
    },
    setSampleTypes(state, value) {
      state.sampleTypes = value;
    },
    resetData(state) {
      state.servicesFamilies = [];
      state.idFamilySelected = null;
      state.idTipoMuestra = null;
      state.servicesAnalytics = [];
      state.showCatalogDetailsPopup = false;
      state.popupTitle = '';
      state.servicesAnalyticsDetails = [];
      state.serviceParameters = [];
      state.serviceNoAnalytics = [];
      state.sampleTypes = [];
    },
  },
};
